
























































import { defineComponent, PropType } from "@vue/composition-api"

// hooks
import useRecharge from "./useRecharge"
import { Info } from "../../config"

// components
import PopupBox from "../PopupBox.vue"
import RechargeAgreement from "../RechargeAgreement/index.vue"
import RechargeBtn from "./RechargeBtn.vue"
import RechargeBtnCustom from "./RechargeBtnCustom.vue"
import RechargeBtnCustomPrompt from "./RechargeBtnCustomPrompt.vue"
import Prompt from "../../../../components/common/Prompt.vue"

export default defineComponent({
  name: "Recharge",
  components: {
    PopupBox,
    RechargeAgreement,
    RechargeBtn,
    RechargeBtnCustom,
    RechargeBtnCustomPrompt,
    Prompt
  },
  props: {
    startPay: {
      // eslint-disable-next-line no-unused-vars
      type: Function as PropType<(num: number, groupid?: string) => Promise<void>>,
      required: true
    },
    showAppleAuth: {
      type: Function as PropType<() => void>,
      required: true
    },
    drmLimitMsg: {
      type: String,
      required: true
    },
    payErrorMsg: {
      type: String,
      required: true
    },
    selectedPayNum: {
      type: Number,
      required: true
    },
    configInfo: {
      type: Object as PropType<Info>,
      required: false,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const recharge = useRecharge(props, emit)
    return recharge
  }
})
